import { useContext, useEffect, useState } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import provider_profile from "../../assets/images/provider_profile.jpg";
import sa_flag from "../../assets/images/sa_flag.jpg";
import saad from "../../assets/images/saad.png";
import { Link, useParams } from "react-router-dom";
import { providerService } from "../../services/providerService";
import { urlConfig } from "../../config/baseUrl";
import Loading from "../../components/common/Loading";
import BackButton from "../../components/common/BackButton";
import no_image_available from "../../assets/images/no_image_available.png";
const ProviderDetails = () => {
  const { t ,lang} = useContext(LocaleContext);
  const {id} = useParams();
  const [data,setData] = useState(null);
  const [loading,setLoading] = useState(true);
  useEffect(() => {
    window.scrollTo(0, 0);
    getDetails();
  }, []);
  const getDetails = async () => {
    try {
      const res = await providerService.getDetail(id);
      setData(res.value);
      console.log(res.value);
    } catch (error) {
      console.error("Error fetching provider details:", error);
    }
    finally {     
       setLoading(false);
    }
  };
  if (loading) return <Loading />;
  return (
    <section className="section-provider-details">
      <div className="default-heading">
        {t("providersDashboardAndManagement")}
      </div>
      <div className="my-card">
        <div className="my-card-header d-flex justify-content-between align-items-center">
          {t("providerDetails")}
          <BackButton />
        </div>
        <div className="my-card-dark">
          <div className="row">
            <div className="col-12 col-md-4">
              <div className="trip-provider-information">
                <div className="trip-provider-profile-layer">
                  <div className="trip-provider-profile">
                    <img
                      src={
                        data?.imagePath
                          ? `${urlConfig.imageBaseUrl}/${data.imagePath}`
                          : provider_profile
                      }
                      alt="Provider Profile"
                    />
                  </div>
                </div>
                {/* <b>
                  <i className="fas fa-images"></i> {t("edit")}
                </b> */}
              </div>
            </div>
            <div className="col-12 col-md-8">
              <div className="row h-100">
                <div className="col-12 col-md-12">
                  <div className="trip-provider-items">
                    <div className="trip-provider-item">
                      <strong>{t("fullName")}</strong>
                      <span>{data?.fullName}</span>
                    </div>
                    <div className="trip-provider-item">
                      <strong>{t("mobileNo")}</strong>
                      <span class="trip-provider-mobile-number">
                        {data?.phoneNumberCode}
                        <div class="trip-mobile-flag-box">
                          <img alt="SA Flag" src={sa_flag} />
                        </div>
                        {data?.phoneNumber}
                      </span>
                    </div>
                    <div className="trip-provider-item">
                      <strong>{t("bankName")}</strong>
                      <span className={data?.bank[lang] ?? "hidden"}>
                        {data?.bank[lang] ? data?.bank[lang] : "_"}
                      </span>
                    </div>
                    <div className="trip-provider-item">
                      <strong>{t("ibanNo")}</strong>
                      <span className={data?.iban ?? "hidden"}>
                        {data?.iban ? data?.iban : "_"}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <div className="trip-provider-items border-0">
                    <div className="trip-provider-item">
                      <strong>{t("city")}</strong>
                      <span>{data?.city[lang]}</span>
                    </div>
                    <div className="trip-provider-item">
                      <strong>{t("balance")}</strong>
                      <span>
                        {data?.balance} {t("riyal")}
                      </span>
                    </div>
                    <div className="trip-provider-item">
                      <strong>{t("totalBookings")}</strong>
                      <span className="text-center">{data?.totalBookings}</span>
                    </div>
                    <div className="trip-provider-item">
                      <strong>{t("totalTrips")}</strong>
                      <span className="text-center">{data?.totalTrips}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="provider-statistics mt-3">
          <strong>{t("statistics")}</strong>
          <section className="provider-statistics mt-3">
            <div className="row g-3">
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-primary">
                  <b>{t("totalTrips")}</b>
                  <span>{data?.totalTrips || 0}</span>
                  <span>
                    {t("active")} : {data?.activeTrips} | {t("pending")} :{" "}
                    {data?.pendingTrips}
                  </span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-dark-blue">
                  <b>{t("totalBookings")}</b>
                  <span>{data?.totalBookings || 0}</span>
                  <span>
                    {t("completed")} : {data?.completedBookings} |{" "}
                    {t("canceled")} : {data?.canceledBookings}
                  </span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-primary">
                  <b>{t("totalProfit")}</b>
                  <span>
                    {data?.totalProfit || 0} {t("riyal")}
                  </span>
                  <span>{t("fromCompletedBookings")}</span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-dark-blue">
                  <b>{t("rated")}</b>
                  <span>{data?.rated || 0} </span>
                  <span>
                    {t("from")} {data?.totalRatings || 0} {t("rating")}
                  </span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-primary">
                  <b>{t("totalTransfers")}</b>
                  <span>
                    {data?.totalTransfers || 0} {t("riyal")}
                  </span>
                  <span>{t("fromCompletedBookings")}</span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="my-box my-bg-dark-blue">
                  <b>{t("noOfAddedCoupons")}</b>
                  <span> {data?.noOfAddedCoupons || 0} </span>
                  <span>{t("coupon")}</span>
                </div>
              </div>
            </div>
          </section>
          <section className="provider-latest-updates mt-3">
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="my-card my-card-scroll provider-detail-list-items">
                  <div className="my-card-header">{t("latestTrips")}</div>
                  {data?.trips?.length > 0 ? (
                    data.trips.map((trip) => (
                      <Link
                        key={trip.tripId}
                        to={`/trip-details/${trip.tripId}`}
                        className="text-decoration-none text-dark"
                      >
                        <div className="provider-latest-updates-item">
                          <div className="provider-latest-updates-image-box">
                            <img src={trip?.imagePath?`${urlConfig.imageBaseUrl}/${trip?.imagePath}`: no_image_available} alt="Saad" />
                          </div>
                          <div className="mt-2">
                            <p className="provider-latest-updates-item-title">
                              <b>{trip.title[lang]}</b>
                            </p>
                            <p className="badge-fixed">
                              {trip.isActive ? (
                                <span className="badge rounded-pill bg-success">
                                  {t("active")}
                                </span>
                              ) : (
                                <span className="badge rounded-pill bg-danger">
                                  {t("inActive")}
                                </span>
                              )}
                            </p>
                            <p className="provider-latest-updates-item-date">
                              {trip.date?.toDate()}
                            </p>
                          </div>
                        </div>
                      </Link>
                    ))
                  ) : (
                    <div>
                      <div className="provider-latest-updates-image-box">
                        <img src={saad} alt="Saad" />
                      </div>
                      <p className="text-center">{t("noRecentTrips")}</p>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="my-card my-card-scroll provider-detail-list-items">
                  <div className="my-card-header">{t("latestBookings")}</div>
                  {data?.bookings?.length > 0 ? (
                    data.bookings.map((booking) => (
                      <Link key={booking.bookingId} to={`/booking-details/${booking.bookingId}`} className="text-decoration-none text-dark">
                        <div
                          key={booking.bookingId}
                          className="provider-latest-updates-item"
                        >
                          <div className="mt-2">
                            <div className="d-flex justify-content-between">
                              <p className="provider-latest-updates-item-title">
                                <b>{booking.title[lang]}</b>
                              </p>
                              <p className="">
                                <span
                                  className={`badge rounded-pill ${booking.status}`}
                                >
                                  {t(booking.status)}
                                </span>
                              </p>
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                              <p className="provider-latest-updates-item-title">
                                <b>{t("code")}: </b>
                                <span>{booking.code}</span>
                              </p>
                              <p style={{ width: "50px", height: "50px" }}>
                                <img
                                  src={booking?.imagePath?`${urlConfig.imageBaseUrl}/${booking?.imagePath}`: no_image_available} 
                                  alt="Saad"
                                  className="booking-image"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                              </p>
                            </div>
                            <div className="d-flex justify-content-between">
                              <p className="provider-latest-updates-item-date text-dim">
                                {booking.date?.toDate()}
                              </p>
                              <p className="badge bg-primary d-flex align-items-center">
                                {booking.totalCost} {t("riyal")}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Link>
                    ))
                  ) : (
                    <div>
                      <div className="provider-latest-updates-image-box">
                        <img src={saad} alt="Saad" />
                      </div>
                      <p className="text-center">{t("noRecentBookings")}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
          <div className="mt-3 d-flex justify-content-end">
            <Link to="/providers">
              <button className="btn-secondary">{t("back")}</button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProviderDetails;
